import React from 'react'

const Ads = () => {
  return <h2>Ads</h2>
}

export default Ads
